import { createFileRoute } from "@tanstack/react-router";

import TodosStandard from "@/features/todos/todos-standard";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/eingang/standard",
)({
  component: PayableStandardPage,
  staticData: {
    breadcrumb: ["todos.payable.title"],
  },
});

function PayableStandardPage() {
  return <TodosStandard type="payable" />;
}
